import React, { useState } from "react";
import { useAuth } from "../../../../Context/AuthContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Spinner } from "react-bootstrap";
import { NotContent } from "../../../ui/Form";
import { httpClient } from "../../../../utils/HttpClient";
import { today } from "../../../../utils/dateHelpers";
import { useMutation } from "@tanstack/react-query";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { DateFilters } from "../../../ui/Form/Period";
import _Button from "../../../generic/_Button";
import { ErrorMessage } from "../../../../utils/toastify";
import TableCustomers from "./TableCustomers";
import { errorLabels } from "../../../../utils/helpers";
const _ReportCustomerSmryMultichannel = () => {
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const [customerSmryMultichannel, setCustomerSmryMultichannel] = useState([]);

  const formik = useFormik({
    initialValues: {
      period: {
        dateFrom: today("YYYY/MM/DD"),
        dateTo: today("YYYY/MM/DD"),
      },
    },
    validationSchema: Yup.object({
      period: Yup.object({
        dateFrom: Yup.string().required("La fecha de inicio es requerida"),
        dateTo: Yup.string().required("La fecha de fin es requerida"),
      }),
    }),
    onSubmit: (values) => {
      mutate(values);
    },
  });

  const { mutate, isPending: isLoadingCustomers } = useMutation({
    mutationFn: async (values) => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}administration/report/customersmrymultichannel`,
        {
          from: values.period.dateFrom,
          to: values.period.dateTo,
        },
        token
      );

      return response.data;
    },
    onSuccess: (response) => {
      setCustomerSmryMultichannel(response);
    },
  });

  const renderContent = () => {
    if (isLoadingCustomers) {
      return (
        <div className="w-full min-h-[60vh] flex justify-center items-center">
          <Spinner animation="border" />
        </div>
      );
    }

    if (!customerSmryMultichannel.length) {
      return (
        <div className="w-full min-h-[60vh] flex justify-center items-center">
          <NotContent />
        </div>
      );
    }

    return (
      <div className="bg-white rounded-lg px-4 py-2 mt-4">
        <TableCustomers data={customerSmryMultichannel} />
      </div>
    );
  };

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  return (
    <div>
      <div className="bg-white rounded-lg px-4 py-2">
        <div className="grid grid-cols-1 gap-4">
          <DateFilters
            required
            setFilterFrom={(e) => formik.setFieldValue("period.dateFrom", e)}
            setFilterTo={(e) => formik.setFieldValue("period.dateTo", e)}
            errors={formik.errors}
            isClean={
              !formik.values.period.dateFrom && !formik.values.period.dateTo
            }
          />
        </div>
        <div className="gap-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
          <div>
            <_Button
              icon="clear_all"
              onClick={() => {
                formik.resetForm();
              }}
              disabled={isLoadingCustomers}
              loading={isLoadingCustomers}
              style="none"
              title="Limpiar"
              className="w-full"
            />
          </div>
          <div>
            <_Button
              icon="analytics"
              onClick={async () => await _validate()}
              style="primary"
              title="Generar reporte"
              disabled={isLoadingCustomers}
              loading={isLoadingCustomers}
              className="w-full"
            />
          </div>
        </div>
      </div>

      {renderContent()}
    </div>
  );
};

export default _ReportCustomerSmryMultichannel;
